import { z } from 'zod';
import { NotificationTimingSchema, NotificationTimingUpsertSchema } from './timing.js';
/**
 * A named sequence of send times. The schedule says *when*; a notification scheme pairs it with the
 * content to send at each of its timings.
 */
export const NotificationScheduleSchema = z.object({
    id: z.uuid(),
    created: z.iso.datetime(),
    updated: z.iso.datetime(),
    name: z.string(),
    organizationId: z.uuid().nullable(),
    deletedTimestamp: z.iso.datetime().nullable(),
});
export const NotificationScheduleWithTimingsSchema = NotificationScheduleSchema.extend({
    timings: z.array(NotificationTimingSchema),
});
export const NotificationScheduleListEntrySchema = NotificationScheduleSchema.extend({
    messageCount: z.number(),
    // Aggregated over the schedule's rules, so a schedule that mixes both anchors gets the two labels
    // concatenated, and one with no rules at all gets null.
    relativeTime: z.string().nullable(),
});
export const NotificationScheduleCreateSchema = z
    .object({
    name: z.string().min(1),
    organizationId: z.uuid().optional(),
    timings: z.array(NotificationTimingUpsertSchema).min(1),
})
    .strict();
export const NotificationScheduleCloneSchema = z
    .object({
    newName: z.string().min(1),
})
    .strict();
/**
 * A patch. At least one field must be present, and `deletedTimestamp` accepts only null — the route
 * un-deletes a schedule but never back-dates a deletion. Sending `timings` replaces the whole set.
 */
export const NotificationScheduleUpdateSchema = z
    .object({
    name: z.string().min(1).optional(),
    organizationId: z.uuid().optional(),
    timings: z.array(NotificationTimingUpsertSchema).min(1).optional(),
    deletedTimestamp: z.null().optional(),
})
    .strict()
    .refine((values) => Object.keys(values).length > 0, {
    message: 'At least one field must be provided',
});
export const NotificationScheduleFindAllQuerySchema = z
    .object({
    q: z.string().min(1).optional(),
    name: z.string().min(1).optional(),
    includeDeleted: z.stringbool({ truthy: ['true'], falsy: ['false'] }).optional(),
    organizationIds: z.array(z.uuid()).optional(),
})
    .strict();
/** The list view filters on the same fields as `findAll`, minus the exact-name match. */
export const NotificationScheduleFindAllForListQuerySchema = NotificationScheduleFindAllQuerySchema.omit({ name: true });
//# sourceMappingURL=schedule.js.map